<a (click)="toggleGroup($event)" [sfHtmlAttributes]="item.attributes" class="nav-link nav-group-toggle" href>
    <ng-container *ngTemplateOutlet="iconTemplate; context: { $implicit: item }" />
    <ng-container>{{ item.name }}</ng-container>
    @if (helper.hasBadge(item)) {
        <span [ngClass]="item | sidebarNavBadge">{{ item.badge.text }}</span>
    }
</a>
<sf-sidebar-nav
    (@openClose.done)="onAnimationDone($event)"
    (@openClose.start)="onAnimationStart($event)"
    [@openClose]="open ? 'open' : 'closed'"
    [compact]="compact"
    [dropdownMode]="dropdownMode"
    [groupItems]="true"
    [navItems]="navItems"
    [ngStyle]="display" />

<ng-template #iconTemplate let-item>
    <!--  <i *ngIf="item?.icon" [ngClass]="item | cSidebarNavIcon"></i>-->
    @if (item?.icon) {
        <span class="nav-icon">
            <span [ngClass]="item.icon ?? ''"></span>
        </span>
    }
    @if (item?.faIcon) {
        <div class="nav-icon">
            <fa-icon [icon]="item.faIcon"></fa-icon>
        </div>
    }
    @if (!item?.icon && !item?.faIcon) {
        <span [ngClass]="item | sidebarNavIcon"></span>
    }
</ng-template>
